const popup = {
    EN: {
        cannotUndo: 'This action cannot be undone.',
        cancel: 'Cancel',
        DELETE_FLEET_CAR: 'Fleet car delete',
        DELETE_FLEET_CAR__description: 'Are you sure you want to delete choosen car from fleet?',
        DELETE_FLEET_CAR__confirmation: 'Yes, delete',
        DELETE_FLEET: 'Fleet delete',
        DELETE_FLEET__description: 'Are you sure you want to delete choosen fleet?',
        DELETE_FLEET__confirmation: 'Yes, delete',
        BLOCK_USER: 'User block',
        BLOCK_USER__description: 'Are you sure you want to block choosen user?',
        BLOCK_USER__confirmation: 'Yes, block',
        UNBLOCK_USER: 'User unblock',
        UNBLOCK_USER__description: 'Are you sure you want to unblock choosen user?',
        UNBLOCK_USER__confirmation: 'Yes, unblock',
        CONFIRM_ORDER: 'Confirm terminal installation',
        CONFIRM_ORDER__description: 'Are you sure you want to confirm terminal installation?',
        CONFIRM_ORDER__confirmation: 'Yes, confirm',
        CANCEL_ORDER__description: 'Are you sure you want to cancel terminal installation?',
        CANCEL_ORDER__confirmation: 'Yes, cancel',
        COLLISION_URL_EXTERNAL__description: 'Link który pozwala podejrzeć wypadek osobie niezalogowanej',
        COLLISION_URL_EXTERNAL__confirmation: 'OK',
        EMPTY: '',
        EMPTY__description: '',
        EMPTY__confirmation: 'OK',
        CAR_ROAD_URL_EXTERNAL__description: 'Link który pozwala podejrzeć trasę samochodu osobie niezalogowanej:',
        CAR_ROAD_URL_EXTERNAL__confirmation: 'OK',
        CANCEL_DATE: 'Cancel installation',
        CANCEL_DATE__description: 'Are you sure you want to cancel installation date?',
        CANCEL_DATE__confirmation: 'Tak, potwierdzam',
        RESET_PASSWORD: 'Reset password for user',
        RESET_PASSWORD__description: 'Are you sure you want to reset password for current user??',
        RESET_PASSWORD__confirmation: 'Yes, reset',
        CONFIRM_TURN_ON: 'Turn on a car again',
        CONFIRM_TURN_ON__description: 'Are you sure you want turn on a car again?',
        CONFIRM_TURN_ON__confirmation: 'Yes, turn on',
        CONFIRM_TURN_OFF_SIM: 'Turn off SIM',
        CONFIRM_TURN_OFF_SIM__description: 'Are you sure you want turn off SIM? You cannot undo this operation!',
        CONFIRM_TURN_OFF_SIM__confirmation: 'Yes'
    },
    PL: {
        cannotUndo: 'Nie będziesz mógł cofnąć tej akcji.',
        cancel: 'Anuluj',
        DELETE_FLEET_CAR: 'Usuwanie pojazdu z floty',
        DELETE_FLEET_CAR__description: 'Czy na pewno chcesz usunąć wybrany pojazd z floty?',
        DELETE_FLEET_CAR__confirmation: 'Tak, usuń',
        DELETE_FLEET: 'Usuwanie floty',
        DELETE_FLEET__description: 'Czy na pewno chcesz usunąć wybraną flotę?',
        DELETE_FLEET__confirmation: 'Tak, usuń',
        DELETE_ALERT: 'Usuwanie alertu',
        DELETE_ALERT__description: 'Czy na pewno chcesz usunąć wybrany alert?',
        DELETE_ALERT__confirmation: 'Tak, usuń',
        BLOCK_USER: 'Blokowanie użytkownika',
        BLOCK_USER__description: 'Czy na pewno chcesz zablokować wybranego użytkownika?',
        BLOCK_USER__confirmation: 'Tak, zablokuj',
        UNBLOCK_USER: 'Odblokowanie użytkownika',
        UNBLOCK_USER__description: 'Czy na pewno chcesz odblokować wybranego użytkownika?',
        UNBLOCK_USER__confirmation: 'Tak, odblokuj',
        DELETE_POI: 'Usuń POI',
        DELETE_POI__description: 'Czy na pewno chcesz usunąć POI?',
        DELETE_POI__confirmation: 'Tak, usuń',
        DELETE_AOI: 'Usuń strefę',
        DELETE_AOI__description: 'Czy na pewno chcesz usunąć wybraną strefę?',
        DELETE_AOI__confirmation: 'Tak, usuń',
        CONFIRM_ORDER: 'Zatwierdź instalację',
        CONFIRM_ORDER__description: 'Czy na pewno chcesz potwierdzić montaż terminalu?',
        CONFIRM_ORDER__confirmation: 'Tak, potwierdzam',
        CANCEL_ORDER__description: 'Czy na pewno chcesz anulować zlecenie montażu terminalu?',
        CANCEL_ORDER__confirmation: 'Tak, anuluj',
        COLLISION_URL_EXTERNAL: 'Link',
        COLLISION_URL_EXTERNAL__description: 'Link który pozwala podejrzeć wypadek osobie niezalogowanej:',
        COLLISION_URL_EXTERNAL__confirmation: 'OK',
        EMPTY: '',
        EMPTY__description: '',
        EMPTY__confirmation: 'OK',
        CAR_ROAD_URL_EXTERNAL: 'Link',
        CAR_ROAD_URL_EXTERNAL__description: 'Link który pozwala podejrzeć trasę samochodu osobie niezalogowanej:',
        CAR_ROAD_URL_EXTERNAL__confirmation: 'OK',
        CANCEL_DATE: 'Anulowanie montażu',
        CANCEL_DATE__description: 'Czy na pewno chcesz anulować zaplanowany montaż terminalu?',
        CANCEL_DATE__confirmation: 'Tak, potwierdzam',
        RESET_PASSWORD: 'Reset hasła',
        RESET_PASSWORD__description: 'Czy jesteś pewny, że chcesz rozpocząć procedurę resetu hasła użytkownika? Do użytkownika zostanie wysłana wiadomość email, zawierająca link jednorazowy, umożliwiający reset hasła.',
        RESET_PASSWORD__confirmation: 'Tak',
        CONFIRM_TURN_ON: 'Ponowne włączanie samochodu',
        CONFIRM_TURN_ON__description: 'Czy jesteś pewny, że chcesz ponownie włączyć samochód?',
        CONFIRM_TURN_ON__confirmation: 'Tak',
        CONFIRM_TURN_OFF_SIM: 'Wyłączenie karty SIM',
        CONFIRM_TURN_OFF_SIM__description: 'Czy jesteś pewny, że chcesz włączyć kartę SIM? Ta operacja jest nieodwracalna!',
        CONFIRM_TURN_OFF_SIM__confirmation: 'Tak'
    }
};

export default popup;



// WEBPACK FOOTER //
// ./src/Translations/Popup.ts